import React, { useState, useEffect } from 'react';
import { FaTimes, FaPlus, FaSearch, FaTrash, FaEdit } from 'react-icons/fa';
import AssigningProject from './AssigningProject';
import UpdateEmployeeProject from './UpdateEmployeeProject';
import './AddEmployeeProject.css';
import { API_URL } from './API';

const AddEmployeeProject = ({ project, onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [employees, setEmployees] = useState([]);
  const [showAssignForm, setShowAssignForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (project) {
      fetchProjectEmployees();
    }
  }, [project]);

  const fetchProjectEmployees = async () => {
    try {
      setLoading(true);
     
      
      const response = await fetch(`${API_URL}/projects/get_employee_to_projects`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      
      if (result.status === 'success' && result.data) {
        const projectEmployees = result.data.filter(
          emp => emp.project_id === project.project_id
        );
        
        const formattedEmployees = projectEmployees.map(emp => ({
          id: emp.employee_id,
          name: emp.employee_name,
          role: emp.role,
          location: emp.location,
          phone: emp.phone_number,
          assignedBy: emp.assigned_by,
          status: 'Active',
          assignmentDate: emp.assignment_date,
          endingDate: emp.ending_date,
          assignmentId: emp.id
        }));
        
        setEmployees(formattedEmployees);
        
      } else if (result.status === 'error' && result.message === 'No employee-project assignments found') {
        setEmployees([]);
        
      } else {
        
        setEmployees([]);
      }
    } catch (error) {
     
      if (error.message.includes('404')) {
        setEmployees([]);
      } else {
        alert('Failed to fetch employees. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleAddEmployee = () => {
    setShowAssignForm(true);
  };

  const handleEditEmployee = (employee) => {
    setSelectedEmployee(employee);
    setShowUpdateForm(true);
  };


  const handleEmployeeAdded = (newEmployee) => {
  fetchProjectEmployees();
  setShowAssignForm(false);
};

  const handleEmployeeUpdated = () => {
    fetchProjectEmployees();
    setShowUpdateForm(false);
    setSelectedEmployee(null);
    
  };

  const handleRemoveEmployee = async (employee) => {
    if (window.confirm(`Are you sure you want to remove ${employee.name} from this project?`)) {
      try {
       
        
        const formData = new FormData();
        formData.append('id', employee.assignmentId);

        const response = await fetch(`${API_URL}/projects/delete_employee_to_project`, {
          method: 'DELETE',
          body: formData
        });

        const result = await response.json();

        if (!response.ok || result.status === 'error') {
          throw new Error(result.message || 'Failed to delete employee assignment');
        }

        
        fetchProjectEmployees();
        alert('Employee removed successfully!');
      } catch (error) {
       
        alert(`Failed to remove employee: ${error.message}`);
      }
    }
  };

  const filteredEmployees = employees.filter((employee) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      String(employee.id || '').toLowerCase().includes(searchLower) ||
      String(employee.name || '').toLowerCase().includes(searchLower) ||
      String(employee.role || '').toLowerCase().includes(searchLower) ||
      String(employee.location || '').toLowerCase().includes(searchLower)
    );
  });

  return (
    <>
      {!showAssignForm && !showUpdateForm && (
        <div className="AEEP-00">
          <div className="AEEP-01">
            <div className="AEEP-02">
              <div>
                <h2>Manage Project Employees</h2>
                <p className="AEEP-03">Project: {project?.project_name || 'Unknown Project'}</p>
              </div>
              <FaTimes className="AEEP-04" onClick={onClose} />
            </div>

            <div className="AEEP-05">
              <div className="AEEP-06">
                <div className="AEEP-07">
                  <FaSearch className="AEEP-08" />
                  <input
                    type="text"
                    className="AEEP-09"
                    placeholder="Search employees"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>

                <button className="AEEP-10" onClick={handleAddEmployee}>
                  <FaPlus /> Add Employee to Project
                </button>
              </div>

              <div className="AEEP-11">
                {loading ? (
                  <div className="AEEP-16">Loading employees...</div>
                ) : (
                  <table className="AEEP-12">
                    <thead>
                      <tr className="AEEP-13">
                        <th className="AEEP-14">EMPLOYEE ID</th>
                        <th className="AEEP-14">EMPLOYEE NAME</th>
                        <th className="AEEP-14">ROLE</th>
                        <th className="AEEP-14">LOCATION</th>
                        <th className="AEEP-14">PHONE NO</th>
                        <th className="AEEP-14">ASSIGNED BY</th>
                        <th className="AEEP-14">STATUS</th>
                        <th className="AEEP-14">ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody className="AEEP-15">
                      {filteredEmployees.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="AEEP-16">
                            {searchQuery 
                              ? `No employees found matching "${searchQuery}"` 
                              : 'No employees assigned to this project yet'}
                          </td>
                        </tr>
                      ) : (
                        filteredEmployees.map((employee) => (
                          <tr key={employee.id} className="AEEP-17">
                            <td className="AEEP-18">{employee.id}</td>
                            <td className="AEEP-18">{employee.name}</td>
                            <td className="AEEP-18">{employee.role}</td>
                            <td className="AEEP-18">{employee.location}</td>
                            <td className="AEEP-18">{employee.phone}</td>
                            <td className="AEEP-18">{employee.assignedBy}</td>
                            <td className="AEEP-18">
                              <span className={`AEEP-19 AEEP-19--${employee.status.toLowerCase().replace(' ', '-')}`}>
                                {employee.status}
                              </span>
                            </td>
                            <td className="AEEP-18">
                              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                <FaEdit 
                                  className="icon-action edit-icon" 
                                  title="Edit Employee"
                                  onClick={() => handleEditEmployee(employee)}
                                  style={{ cursor: 'pointer', color: '#000' }}
                                />
                                <FaTrash 
                                  className="icon-action delete-icon" 
                                  title="Remove Employee"
                                  onClick={() => handleRemoveEmployee(employee)}
                                  style={{ cursor: 'pointer', color: '#000' }}
                                />
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showAssignForm && (
        <AssigningProject
          project={project}
          onClose={() => setShowAssignForm(false)}
          onEmployeeAdded={handleEmployeeAdded}
        />
      )}

      {showUpdateForm && (
        <UpdateEmployeeProject
          project={project}
          employee={selectedEmployee}
          onClose={() => {
            setShowUpdateForm(false);
            setSelectedEmployee(null);
          }}
          onEmployeeUpdated={handleEmployeeUpdated}
        />
      )}
    </>
  );
};

export default AddEmployeeProject;